(() => {
  const STORAGE_KEY = 'vb_recently_viewed_products';
  const MAX_PRODUCTS = 12;

  function safeParse(value) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function getRecentlyViewed() {
    return safeParse(localStorage.getItem(STORAGE_KEY))
      .filter((handle) => typeof handle === 'string' && handle.trim() !== '');
  }

  function setRecentlyViewed(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_PRODUCTS)));
  }

  function saveCurrentProduct() {
    const currentHandle = window.vbCurrentProductHandle;

    if (!currentHandle || typeof currentHandle !== 'string') {
      return;
    }

    const handles = getRecentlyViewed()
      .filter((handle) => handle !== currentHandle);

    handles.unshift(currentHandle);

    setRecentlyViewed(handles);
  }

  function getRecentlyViewedWithoutCurrent(limit = MAX_PRODUCTS) {
    const currentHandle = window.vbCurrentProductHandle;

    return getRecentlyViewed()
      .filter((handle) => handle !== currentHandle)
      .slice(0, limit);
  }

  window.vbRecentlyViewed = {
    get: getRecentlyViewed,
    getWithoutCurrent: getRecentlyViewedWithoutCurrent,
    saveCurrentProduct,
    clear() {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  saveCurrentProduct();
  document.dispatchEvent(new CustomEvent('abRecentlyViewedReady'));
})();